<template>
	<div class="row">
		<div class="col">
			<div class="py-5 text-center">
				<h2>Benefícios do EAD</h2>
				<p class="lead">
					100% das aulas online com conteúdos desenvolvidos para
					aprendizado remoto com vídeos curtos e linguagem digital.
					Conheça outras vantagens de estudar online com a
					Habilite-se.
				</p>
			</div>
		</div>
	</div>
	<div class="row mb-4">
		<div class="col-md-12 col-xl-12 col-lg-12">
			<div class="section3126">
				<div class="row">
					<div class="col-xl-6 col-lg-12 col-md-6">
						<div class="card value_props">
							<div class="value_icon">
								<i
									class="uil uil-history fa-3x"
									style="background-color: #ffecec"></i>
							</div>
							<div class="value_content">
								<h4>Vá em seu próprio ritmo</h4>
								<p>
									Aproveite o acesso vitalício a cursos no
									site da Habilite-se
								</p>
							</div>
						</div>
					</div>
					<div class="col-xl-6 col-lg-12 col-md-6">
						<div class="card value_props">
							<div class="value_icon">
								<i class="uil uil-user-check fa-3x"></i>
							</div>
							<div class="value_content">
								<h4>Aprenda de qualquer lugar</h4>
								<p>Acesso online e ilimitado</p>
							</div>
						</div>
					</div>
					<div class="col-xl-6 col-lg-12 col-md-6">
						<div class="card value_props">
							<div class="value_icon">
								<i class="uil uil-play-circle fa-3x"></i>
							</div>
							<div class="value_content">
								<h4>Encontre cursos em vídeo</h4>
								<p>
									Escolha a bibliotéca ideal para seu melhor
									aproveitamento
								</p>
							</div>
						</div>
					</div>
					<div class="col-xl-6 col-lg-12 col-md-6">
						<div class="card value_props">
							<div class="value_icon">
								<i class="uil uil-presentation-play fa-3x"></i>
							</div>
							<div class="value_content">
								<h4>Todos os cursos sobre trânsito</h4>
								<p>
									Explore uma variedade de novos tópicos todos
									os dias
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<style scoped>
	.value_props {
		background: #fff;
		border-radius: 10px;
		padding: 20px;
		flex: 1;
		float: left;
		width: 100%;
		margin-top: 30px;
		text-align: center;
	}

	.value_icon i {
		font-size: 36px;
		margin-right: 0;
		color: #333;
		background: #ffecec;
		border-radius: 10px;
		padding: 10px 6px;
		display: inline-block;
	}
	.value_content {
		width: 100%;
		margin-top: 20px;
	}

	.value_content h4 {
		font-size: 18px;
		margin-bottom: 9px;
		display: block;
		font-weight: 500;
		color: #333;
		text-align: center;
	}

	.value_content p {
		font-weight: 500;
		font-family: 'Roboto', sans-serif;
		text-align: left;
		line-height: 26px;
		color: #686f7a;
		text-align: center;
	}
</style>
